/**
 * NOS-125: Dashboard CRUD for media_series with video counts.
 * NOS-262: instantiation of the org-taxonomy factory.
 */
import type { Database } from "@/types/database"
import { generateSlug } from "@/lib/slugUtils"
import { makeOrgTaxonomyHook } from "./useOrgTaxonomy"

type MediaSeries = Database["public"]["Tables"]["media_series"]["Row"]

export interface MediaSeriesWithCount extends MediaSeries {
  video_count: number
}

export interface MediaSeriesInput {
  title: string
  slug?: string
  description?: string | null
  cover_image?: string | null
}

export const useMediaSeries = makeOrgTaxonomyHook<MediaSeriesWithCount, MediaSeriesInput>({
  table: "media_series",
  orderBy: "title",
  duplicateMessage: "A series with this slug already exists.",
  count: { via: "orgColumn", table: "media_videos", fk: "series_id" },
  deleteGuard: {
    table: "media_videos",
    fk: "series_id",
    selectColumn: "id",
    scopeToOrg: true,
    message: "Remove all videos from this series before deleting.",
  },
  prepare: (v) => ({
    title: v.title.trim(),
    slug: v.slug?.trim() || generateSlug(v.title),
    description: v.description?.trim() || null,
    cover_image: v.cover_image || null,
  }),
})
